/**
 * Manual UTF-8 encoding using encodeURIComponent as fallback
 * Used when TextEncoder is not available (older browsers/Node environments)
 */
export function manualUtf8Encode(input: string): Uint8Array {
  const encoded = encodeURIComponent(String(input));
  const bytes: number[] = [];
  for (let i = 0; i < encoded.length; i++) {
    const code = encoded.charCodeAt(i);
    if (code === 37) {
      // %HH
      const hex = encoded.substr(i + 1, 2);
      bytes.push(parseInt(hex, 16));
      i += 2;
    } else {
      bytes.push(code);
    }
  }
  return new Uint8Array(bytes);
}
